/** 모바일 최대 너비 기준 px */
export const MOBILE_MAX_WIDTH = 500;
/** PC 디자인 변경 기준 px */
export const PC_BREAKPOINT = 801; // 801px 이상부터 PC 디자인 적용
/** PC 디자인 최대 width */
export const PC_MAX_WIDTH = 1280;
/** (swiper 버튼을 포함한) PC 디자인 최대 width  */
export const PC_MAX_WIDTH_WITH_SWIPER_BUTTON = 1330;
/** 레거시 PC 디자인 최대 width */
export const LEGACY_PC_MAX_WIDTH = 768;
